// @ts-nocheck
import React from 'react';

import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';

import ActionHandler from 'components/ActionHandler';
import AuthGuard from 'components/AuthGuard';
import Layout from 'components/Layout';
import RootRedirect from 'components/RootRedirect';
import CreateOrganisation from 'pages/CreateOrganisation';

import Dashboard from 'pages/Dashboard';
import Account from 'pages/Account';
import Organisation from 'pages/Organisation';
import Integrations from 'pages/Integrations';
import NewFeatures from 'pages/NewFeatures';
import PenlyAccess from 'pages/PenlyAccess';
import PenlyAccessUsers from 'pages/PenlyAccessUsers';
import PenlyAccessSharings from 'pages/PenlyAccessSharings';
import PenlyAccessMeetings from 'pages/PenlyAccessMeetings';
import PenlyAccessUser from 'pages/PenlyAccessUser';
import PenlyAccessSharing from 'pages/PenlyAccessSharing';
import PenlyAccessOrder from 'pages/PenlyAccessOrder';

import paths from 'paths';


const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={ <ActionHandler /> }>
            <Route element={ <AuthGuard /> }>
                <Route element={ <Layout /> }>
                    <Route path="/" element={ <RootRedirect /> } />
                    <Route path={ paths.start.path } element={ <CreateOrganisation /> } />

                    <Route path={ paths.account.path.withoutOrganisation } element={ <Account /> } />

                    <Route path={ paths.dashboard.path } element={ <Dashboard /> } />
                    <Route path={ paths.account.path.withOrganisation } element={ <Account /> } />
                    <Route path={ paths.organisation.path } element={ <Organisation /> } />
                    <Route path={ paths.newFeatures.path } element={ <NewFeatures /> } />

                    <Route path={ paths.penlyAccess.path } element={ <PenlyAccess /> } />
                    <Route path="/:organisationId/access/brugere" element={ <PenlyAccessUsers /> } />
                    <Route path="/:organisationId/access/delinger" element={ <PenlyAccessSharings /> } />
                    <Route path="/:organisationId/access/moeder" element={ <PenlyAccessMeetings /> } />
                    <Route path={ paths.penlyAccessUser.path } element={ <PenlyAccessUser /> } />
                    <Route path={ paths.penlyAccessSharing.path } element={ <PenlyAccessSharing /> } />
                    <Route path={ paths.penlyAccessOrder.path } element={ <PenlyAccessOrder /> } />

                    <Route path={ paths.integrations.path } element={ <Integrations /> } />
                </Route>
            </Route>
        </Route>,
    ),
    {
        future: {
            // Normalize `useNavigation()`/`useFetcher()` `formMethod` to uppercase
            v7_normalizeFormMethod: true,
        },
    },
);

export default router;
